import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import placeholderImage from '../../../../../assets/images/placeholder.jpg';
import { config } from '../../../../../config/index';
import { GET, newFetch } from '../../../../../helpers/fetch';
const { API_URL } = config;

const AdminDetail = ({ history, match: { params } }) => {
  const admin_id = params.admin_id;

  const [admin, setAdmin] = useState({});
  const [clients, setClients] = useState('');
  const [selectedClients, setSelectedClients] = useState([]);
  const showSiteDetails =
    admin.type === 'client' || Number(admin.is_ops) === 1;

  useEffect(() => {
    const fetchAdmin = async () => {
      try {
        let url = `${API_URL}/admin/admins/${admin_id}`;
        let token = localStorage.getItem('token');

        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        if (response.ok) {
          let data = await response.json();
          setAdmin(data.data);
        } else {
          console.log(response.message);
        }
      } catch (error) {
        console.log(error);
      }
    };

    const fetchClients = async () => {
      let api_path = '/client/options';
      let response = await newFetch(GET, api_path);

      if (response.success) {
        let filtered = response.data.filter((client) => client.active === true);
        setClients(filtered);
      }
    };

    const fetchSelectedClients = async () => {
      let url = `${API_URL}/admin/admins-client/${admin_id}`;
      let token = localStorage.getItem('token');

      let response = await fetch(url, {
        method: 'GET',
        withCredentials: true,
        mode: 'cors',
        headers: {
          Authorization: token,
          'Content-Type': 'application/json; charset=utf-8',
        },
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          setSelectedClients(data.data);
        }
      } else {
        console.error('Network response was not ok', response.statusText);
      }
    };

    fetchAdmin();
    fetchClients();
    fetchSelectedClients();
  }, []);

  return (
    <React.Fragment>
      <div
        className="d-flex justify-content-between bg-white border-bottom"
        style={{ padding: '3rem' }}
      >
        <div className="d-flex flex-column">
          <NavLink
            to="/admins"
            className="text-decoration-none"
            style={{ color: 'inherit' }}
          >
            <div>
              <i className="fas fa-chevron-left pe-2"></i> Admin Management
            </div>
          </NavLink>
          <div className="d-flex align-items-center justify-content-center pt-4">
            <div
              className="rounded-circle border me-3"
              style={{
                position: 'relative',
                width: '6rem',
                height: '6rem',
                borderRadius: '50%',
                overflow: 'hidden',
              }}
            >
              <img
                src={admin.photo ? admin.photo : placeholderImage}
                alt="user"
                style={{
                  maxWidth: '100%',
                }}
              />
            </div>
            <div className="d-flex flex-column">
              <h3>
                {admin.first_name} {admin.last_name}
                <br />
                <span
                  className={`badge rounded-pill ${
                    Number(admin.is_super) === 1
                      ? `bg-danger`
                      : Number(admin.is_ops) === 1
                        ? `bg-primary`
                        : admin.type === 'client'
                          ? `bg-warning`
                          : `bg-secondary`
                  } me-2 p-2 badge-font-11`}
                >
                  {Number(admin.is_super) === 1
                    ? 'Super Admin'
                    : Number(admin.is_ops) === 1
                      ? 'Ops Admin'
                      : admin.type === 'client'
                        ? 'Client Admin'
                        : 'Admin'}
                </span>
              </h3>
              <p>{admin.designation}</p>
            </div>
          </div>
        </div>
        <div className="mt-auto">
          <button
            onClick={() => history.push(`/admins/admin/${admin.id}/edit`)}
            className="btn btn-outline-brand rounded"
            style={{ width: '200px' }}
          >
            Edit Profile
          </button>
        </div>
      </div>
      <div
        className="card bg-white text-dark shadow rounded"
        style={{ margin: '3rem' }}
      >
        <div className="card-body">
          <div className="container-fluid d-flex">
            <div style={{ width: '15rem' }} className="p-2 m-2">
              <strong>Admin Information</strong>
              <p className="pt-2">View and edit admin information</p>
            </div>
            <div className="flex-grow-1 p-2 m-2">
              <div className="row pb-3">
                <div className="col-sm-4">
                  <strong>First Name</strong>
                  <p className="pt-2">{admin.first_name}</p>
                </div>
                <div className="col-sm-4">
                  <strong>Last Name</strong>
                  <p className="pt-2">{admin.last_name}</p>
                </div>
              </div>
              <div className="row pb-3">
                <div className="col-sm-4">
                  <strong>Employee ID</strong>
                  <p className="pt-2">{admin.employee_no}</p>
                </div>
              </div>
              <div className="row pb-3">
                <div className="col-sm-4">
                  <strong>Email</strong>
                  <p className="pt-2">{admin.email}</p>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <strong>Phone No</strong>
                  <p className="pt-2">{admin.phone_no}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card bg-white text-dark shadow rounded"
        style={{ margin: '3rem' }}
      >
        <div className="card-body">
          <div className="container-fluid d-flex">
            <div style={{ width: '15rem' }} className="p-2 m-2">
              <strong>Client Information</strong>
              <p className="pt-2">View and edit admin client information</p>
            </div>
            <div style={{ margin: '2rem' }}>
              {clients &&
                clients.length > 0 &&
                clients.map((client) => {
                  const selectedClient = selectedClients.find(
                    (selectedClient) => selectedClient.client_id === client.id,
                  );
                  const isChecked = Boolean(selectedClient);

                  return (
                    <div key={client.id}>
                      <label style={{ display: 'flex', alignItems: 'center' }}>
                        {isChecked ? (
                          <>
                            <i className="fas fa-check margin-right-5"></i>
                          </>
                        ) : (
                          <>
                            <i className="fas fa-times margin-right-5"></i>
                          </>
                        )}
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <span>{client.name}</span>
                        </div>
                      </label>
                      {showSiteDetails &&
                        isChecked &&
                        client.sites &&
                        client.sites.length > 0 && (
                          <div className="ms-4 mb-2">
                            {client.sites.map((site) => {
                              const isSiteChecked = (
                                selectedClient?.sites || []
                              ).some(
                                (selectedSite) =>
                                  selectedSite.site_id === site.id,
                              );

                              return (
                                <label
                                  key={site.id}
                                  className="mb-2"
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  {isSiteChecked ? (
                                    <i className="fas fa-check margin-right-5"></i>
                                  ) : (
                                    <i className="fas fa-times margin-right-5"></i>
                                  )}
                                  <span>{site.name}</span>
                                </label>
                              );
                            })}
                          </div>
                        )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      </div>
      ;
    </React.Fragment>
  );
};

export default AdminDetail;
